// 全名变量
export default {
  userToken: (state) => {
    return state.userToken
  },
  accessToken: (state) => {
    return state.accessToken
  },
  userData: (state) => {
    return state.userData
  },
  theme: (state) => {
    return state.theme
  },
  chooseDept: state => state.chooseDept,
  chooseDataScopeDept: state => state.chooseDataScopeDept,
  status: state => state.status,
  newUserMenus: state => state.newUserMenus,
  defaultCheckedArray: state => state.defaultCheckedArray,
  studentChooseTree: state => state.studentChooseTree,
  personChargeData: state => state.personChargeData,
  hierarchyTree:state => state.hierarchyTree,
  dialogVisible: state => state.dialogVisible,
  dialogTitle: state => state.dialogTitle,
  formData: state => state.formData,
  labelWidth: state => state.labelWidth,
  radioArray: state => state.radioArray,
  lableArray: state => state.lableArray,
  access_token: state => state.access_token,
  userMenus: state => state.userMenus,
  roleTypeData: state => state.roleTypeData,
  userPermissionTypeDialog: state => state.userPermissionTypeDialog,
  roleFormData: state => state.roleFormData,
  roleFormDialog: state => state.roleFormDialog,
  defaultPageDialog: state => state.defaultPageDialog,
  permissionDialog: state => state.permissionDialog,
  checkedArray: state => state.checkedArray,
  userTypes: state => state.userTypes,
  checkedItemArray: state => state.checkedItemArray,
  permissions: state => state.permissions,
  previewFileData: state => state.previewFileData,
  moduleList: state => state.moduleList,
  unReadMsgCount: state => state.unReadMsgCount
}
